import React, { Component } from 'react'
import { Col, Row, Input, Label } from 'reactstrap'
import ModalForm from '../../../comum/components/ModalForm'
import { observer } from 'mobx-react'
import NovoDirecionamentoStore from '../stores/NovoDirecionamentoStore'
import modeloRecinto from '../../../../assets/downloads/Planilha_direcionamento_recinto.xlsx'
import RadiobuttonGroup from '../../../comum/components/RadiobuttonGroup'
import FormSelectSimples from '../../../comum/components/FormSelectSimples'
import CalendarioPicker from '../../../comum/components/Calendario'
import CheckboxField from '../../../comum/components/CheckboxField'

@observer
export default class ImportarDirecionamento extends Component {

    constructor(props) {
        super(props)

        this.direcController = this.props.controller

        this.controller = new NovoDirecionamentoStore(this.direcController.service)

        this.handleSalvar = this.handleSalvar.bind(this)
    }

    componentDidMount() {
        if(this.direcController.adicionando && this.direcController.listaAdicoes.length > 0) {
            this.controller.setDadosDirecionamento(this.direcController.dadosAdicao)
        } else {
            this.controller.tipoDoc = "DTC"
        }
    }

    handleSalvar() {
        this.controller.adicionar = true
        if(!this.alertaOperacao() && !this.alertaData()){
            this.controller.listaImportacao.map(imp => {
                if(this.direcController.listaAdicoes.length === 0) {
                    this.direcController.setDadosEntrada(this.controller.tipoDoc, this.controller.dtAtracacaoInicio, this.controller.dtAtracacaoFim, this.controller.operacao)
                }
                this.direcController.adicionarListaAdicoes(this.controller.tipoDoc,this.controller.flagCarga,imp.CeHouse,imp.Container, imp.Cnpj,imp.RazaoSocial, this.controller.operacao,[])
            })
            this.direcController.mostrarTabelaAdicionar()
            this.direcController.fecharModalImportar()
        }
    }

    alertaData = () => {
        if(this.controller.adicionar && (this.controller.dtAtracacaoInicio === null || this.controller.dtAtracacaoFim === null)) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    alertaOperacao = () => {
        if(this.controller.adicionar && this.controller.operacao === null) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    render() {
        return (
            <ModalForm
                className="modal-direcionamento"
                salvando={this.controller.loadingImport}
                onClickSalvar={this.handleSalvar}
                labelConfirmar="CONFIRMAR"
                esconderSalvar={this.controller.listaImportacao.length === 0}
                onClickCancelar={this.direcController.fecharModalImportar}
            >
                <h2>
                    Importar xls
                </h2>
                <Row>
                    <RadiobuttonGroup xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Tipo de documento"
                        name="docType"
                        bloqueado={this.direcController.dadosAdicao.tipoDoc ? true : false}
                        //obrigatorio={true}
                        //alerta={this.alertaDocCntr()}
                        onClick={this.controller.setTipoDoc}
                        itens={[
                            { id: "DTC", value: "DTC", label: "DTC", checked: this.controller.tipoDoc === "DTC" },
                            { id: "DTA", value: "DTA", label: "DTA", checked: this.controller.tipoDoc === "DTA" }
                        ]}
                    />
                    <CheckboxField xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Consolidado - Carga Solta"
                        name="flagCarga"
                        bloqueado={this.controller.tipoDoc !== "DTA"}
                        ativo={this.controller.flagCarga}
                        onClick={() => {
                            this.controller.setFlagCarga(!this.controller.flagCarga);
                        }}
                    />
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Label>Previsão de atracação<span className="label-danger">*</span></Label>
                        <CalendarioPicker 
                            onChangeInicio={this.controller.setDataInicio}
                            onChangeFim={this.controller.setDataFim}
                            dataInicial={this.controller.dtAtracacaoInicio}
                            dataFinal={this.controller.dtAtracacaoFim}
                            filtrar={this.controller.listarOperacoes}
                            bloqueado={this.direcController.dadosAdicao.dtInicio || this.direcController.dadosAdicao.dtFim ? true : false}
                        />
                        {this.alertaData() && <Label className="label-danger">{ this.alertaData() }</Label>}
                    </Col>
                    <FormSelectSimples  xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Operação"
                        itens={this.controller.operacoes}
                        dado={this.controller.operacao}
                        bloqueado={
                            this.controller.operacoes.length === 0 || 
                            this.controller.dtAtracacaoInicio === null || 
                            this.controller.dtAtracacaoFim === null ||
                            this.controller.loadingOperacoes ||
                            this.direcController.dadosAdicao.operacao !== null
                        }
                        obrigatorio={true}
                        alerta={this.alertaOperacao()}
                        onChange={this.controller.setOperacao}
                    />
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Label>Anexos</Label>
                        <span className="label-danger">*</span>
                        <Input className="p-2 mb-4" type="file" onChange={e => this.controller.adicionarPlanilha(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" multiple />
                        <Label className="mb-0"><a href={modeloRecinto} download="modelo_direcionamento_Recinto.xlsx">Baixar modelo de planilha</a></Label>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        {this.controller.aviso && <div className='label-obrigatorio pt-2 pb-1'>
                            <Label>{ this.controller.aviso }</Label>
                        </div>}
                    </Col>
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/components/ImportarDirecionamento.js